<div class="wrapper" [routerLink]="routerLink">
    <picture>
        <img [src]="imageSource + '.svg'" class="company-logo" alt="company logo image"/>
    </picture>
    <span class="product-name">{{ productName | uppercase }}</span>
</div>
